export function useShowTotalTerpenes(dispensary) {
    var _dispensary_storeSettings;
    var _dispensary_storeSettings_hideTotalTerpenes;
    return !((_dispensary_storeSettings_hideTotalTerpenes = dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_storeSettings = dispensary.storeSettings) === null || _dispensary_storeSettings === void 0 ? void 0 : _dispensary_storeSettings.hideTotalTerpenes) !== null && _dispensary_storeSettings_hideTotalTerpenes !== void 0 ? _dispensary_storeSettings_hideTotalTerpenes : false);
}
